import { useEffect, useState } from 'react';
import { apiService } from '../services/api.service';

const RENEWAL_LABELS: Record<string, string> = {
  RENEWAL: 'Renovación',
  REENTRY: 'Reingreso',
  REFINANCE: 'Refinanciación',
};

export function LoanRenewals() {
  const [renewals, setRenewals] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      setRenewals(await apiService.listLoanRenewals());
    } catch (e: any) {
      setError(e?.response?.data?.message ?? e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Renovaciones</h1>
          <p className="text-sm text-gray-500 mt-1">Préstamos originados por renovación o reingreso</p>
        </div>
        <button onClick={load} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200">
          Actualizar
        </button>
      </div>

      {error && (
        <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200 text-red-700 text-sm">{error}</div>
      )}

      {loading ? (
        <p className="text-gray-500">Cargando…</p>
      ) : renewals.length === 0 ? (
        <p className="text-gray-500">No hay renovaciones registradas.</p>
      ) : (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nº préstamo</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cliente</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tipo</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Monto</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Origen</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Plan</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {renewals.map((r) => (
                <tr key={r.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium">{r.loanNumber ?? r.id.slice(0, 8)}</td>
                  <td className="px-4 py-3 text-sm">
                    {r.customer?.firstName} {r.customer?.lastName}
                    <span className="text-gray-400 text-xs block">{r.customer?.documentNumber}</span>
                  </td>
                  <td className="px-4 py-3 text-sm">{RENEWAL_LABELS[r.renewalType] ?? r.renewalType}</td>
                  <td className="px-4 py-3 text-sm">${r.amount?.toLocaleString()}</td>
                  <td className="px-4 py-3 text-sm">
                    #{r.parentLoan?.loanNumber ?? r.parentLoanId?.slice(0, 8)}
                    <span className="text-gray-400 text-xs block">${r.parentLoan?.amount?.toLocaleString()}</span>
                  </td>
                  <td className="px-4 py-3 text-sm">{r.product?.planCode ?? r.product?.name}</td>
                  <td className="px-4 py-3 text-sm">{r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
